<!-- src/app/components/account/change-password/change-password.component.html -->
<div class="change-password-container mat-typography">
  <mat-card class="change-password-card">
    <div class="card-header">
      <mat-icon aria-hidden="true">key</mat-icon>
      <div class="titles">
        <h2 class="title">Change Password</h2>
        <p class="subtitle">Enter your current password and choose a new one.</p>
      </div>
    </div>

    @if (errorMessage) {
      <div class="alert alert-error" role="alert" aria-live="assertive">
        <mat-icon aria-hidden="true">error</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
    }
    @if (successMessage) {
      <div class="alert alert-success" role="status" aria-live="polite">
        <mat-icon aria-hidden="true">check_circle</mat-icon>
        <span>{{ successMessage }}</span>
      </div>
    }

    <div class="content">
      <!-- LEFT: FORM -->
      <form class="change-password-form" [formGroup]="form" (ngSubmit)="submit()">
        <!-- Current Password (full width) -->
        <mat-form-field appearance="outline" floatLabel="always" class="col-span-2">
          <mat-label>Current Password</mat-label>
          <input
            matInput
            [type]="hideCurrent ? 'password' : 'text'"
            formControlName="currentPassword"
            required
            autocomplete="current-password"
            aria-required="true"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideCurrent = !hideCurrent"
            [attr.aria-label]="hideCurrent ? 'Show password' : 'Hide password'"
          >
            <mat-icon>{{ hideCurrent ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.get('currentPassword')?.hasError('required')">
            Current password is required.
          </mat-error>
        </mat-form-field>

        <!-- New Password (left) -->
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>New Password</mat-label>
          <input
            matInput
            [type]="hideNew ? 'password' : 'text'"
            formControlName="newPassword"
            required
            autocomplete="new-password"
            aria-required="true"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideNew = !hideNew"
            [attr.aria-label]="hideNew ? 'Show password' : 'Hide password'"
          >
            <mat-icon>{{ hideNew ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          <mat-hint>
            At least 12 characters, must include uppercase, lowercase, number, and special character.
          </mat-hint>
          <mat-error *ngIf="form.get('newPassword')?.hasError('required')">
            New password is required.
          </mat-error>
          <mat-error *ngIf="form.get('newPassword')?.hasError('minlength')">
            Must be at least 12 characters.
          </mat-error>
          <mat-error *ngIf="form.get('newPassword')?.hasError('pattern')">
            Must include uppercase, lowercase, a number, and a special character.
          </mat-error>
        </mat-form-field>

        <!-- Confirm Password (right) -->
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Confirm New Password</mat-label>
          <input
            matInput
            [type]="hideConfirm ? 'password' : 'text'"
            formControlName="confirmPassword"
            required
            autocomplete="new-password"
            aria-required="true"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideConfirm = !hideConfirm"
            [attr.aria-label]="hideConfirm ? 'Show password' : 'Hide password'"
          >
            <mat-icon>{{ hideConfirm ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">
            Confirmation is required.
          </mat-error>
          <mat-error *ngIf="form.hasError('mismatch')">
            Passwords do not match.
          </mat-error>
        </mat-form-field>

        <!-- Actions -->
        <div class="action-row col-span-2">
          <button
            type="submit"
            mat-raised-button
            color="primary"
            [disabled]="isSubmitting || form.invalid"
          >
            {{ isSubmitting ? 'Saving…' : 'Change Password' }}
          </button>
          <button type="button" mat-button [routerLink]="['/']">Cancel</button>
        </div>
      </form>

      <!-- RIGHT: REQUIREMENTS PANEL -->
      <aside class="help-panel">
        <h3><mat-icon aria-hidden="true">info</mat-icon> Password Requirements:</h3>
        <ul>
          <li>Must be at least 12 characters long</li>
          <li>Must include a lowercase letter</li>
          <li>Must include an uppercase letter</li>
          <li>Must include a number</li>
          <li>Must include a special character</li>
        </ul>
      </aside>
    </div>
  </mat-card>
</div>
